import React, { useState } from "react";
import { Text, View, StyleSheet } from "react-native";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import registerPushNotifications from "../../notifications/push/register";
import Button from "../../forms/button";
import TextInput from "../../forms/textInput";
import { Formik, Field } from "formik";
import { Theme, attributes } from "../../theme";
import styled from "styled-components/native";

const CenteredContainer = styled.View`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  min-height: 500;
`;

const JoinText = styled.Text`
  color: ${attributes.mainColor};
  font-size: 30px;
`;

const ErrorText = styled.Text`
  color: ${attributes.errorColor};
  margin-bottom: 20px;
`;

const InputContainer = styled.View`
  margin-top: 20px;
`;

const ButtonContainer = styled.View`
  margin: 20px 0;
  width: 175px;
`;

const handleSubmit = async ({
  data,
  setIsSubmitting,
  joinGameRequest,
  setError,
  navigate,
}) => {
  setIsSubmitting(true);
  try {
    const { id, name } = data;
    const pushToken = await registerPushNotifications();

    const result = await joinGameRequest({
      variables: { id: id.toLowerCase(), name, pushToken },
    });
    global.RunningGame = { game: result.data.joinGame, name };

    setIsSubmitting(false);
    navigate("CurrentGame");
  } catch (error) {
    console.log(error.message, error.stack);
    setError(`Game ${data.id} could not be found`);
    setIsSubmitting(false);
  }
};

const validateInput = ({ id, name, setIsValid }) => {
  let isValid = true;

  if (!name || !name.trim()) {
    isValid = false;
  }

  if (!id || !id.trim()) {
    isValid = false;
  }

  setIsValid(isValid);
};

const JoinGame = (props) => {
  const [error, setError] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <Theme>
      <Formik
        validate={(data) => validateInput({ ...data, setIsValid })}
        onSubmit={(data) => {
          handleSubmit({
            data,
            setIsSubmitting,
            joinGameRequest: props.joinGame,
            setError,
            navigate: props.navigation.navigate,
          });
        }}
        initialValues={{
          id: null,
          name: null,
        }}
        render={({ handleSubmit }) => (
          <CenteredContainer>
            <View>
              <JoinText>Join a game</JoinText>
            </View>
            <View>
              <InputContainer>
                <Field
                  component={TextInput}
                  disabled={isSubmitting}
                  name="id"
                  placeholder="Game ID"
                  width={175}
                  inputStyle={{
                    textAlign: "center",
                    width: 155,
                  }}
                />
              </InputContainer>
              <InputContainer>
                <Field
                  component={TextInput}
                  disabled={isSubmitting}
                  name="name"
                  placeholder="Your name"
                  width={175}
                  inputStyle={{
                    textAlign: "center",
                    width: 155,
                  }}
                />
              </InputContainer>
            </View>
            <ButtonContainer>
              {error && <ErrorText>{error}</ErrorText>}
              <Button
                title="JOIN GAME"
                disabled={!isValid || isSubmitting}
                onPress={handleSubmit}
              >
                Join game
              </Button>
            </ButtonContainer>
          </CenteredContainer>
        )}
      />
    </Theme>
  );
};

const JOIN_GAME_MUTATION = gql`
  mutation createJoinGameMutation(
    $id: String!
    $name: String!
    $pushToken: String
  ) {
    joinGame(id: $id, name: $name, pushToken: $pushToken) {
      id
      status
      owner {
        id
      }
      levels {
        drinks
      }
    }
  }
`;

const JoinGameWithMutation = graphql(JOIN_GAME_MUTATION, {
  name: "joinGame",
})(JoinGame);

export default JoinGameWithMutation;
